<template>
  <AppModal :model-value="Boolean(store.purchase)" :title="t('purchase.benchmark')" @cancel="store.choose(false)" @update:model-value="value => { if (!value) store.choose(false); }">
    <div v-if="store.purchase" class="space-y-4">
      <p v-if="store.purchase.scenario_count">{{ t(store.purchase.days_per_scenario ? 'purchase.summary_per_scenario' : 'purchase.summary', { scenarios: store.purchase.scenario_count, days: store.purchase.days_per_scenario || store.purchase.scenario_days, tokens: store.purchase.tokens }) }}</p>
      <p v-else>{{ t('purchase.tokens', { count: store.purchase.tokens }) }}</p>
      <p>{{ t('purchase.available', { count: tokens.totalBalance }) }}</p>
      <p class="text-sm text-theme-text-secondary">{{ t('purchase.tax_note') }}</p>
      <AppAlert v-if="error" tone="danger">{{ error }}</AppAlert>
      <div class="flex flex-wrap gap-2">
        <AppButton :disabled="busy || tokens.totalBalance < store.purchase.tokens" data-test="benchmark-use-tokens" @click="store.choose(true)">{{ t('purchase.use_tokens') }}</AppButton>
        <AppButton :loading="busy" variant="outline" data-test="benchmark-pay" @click="pay">{{ t('purchase.pay', { amount: money }) }}</AppButton>
        <AppButton v-if="!isPro" variant="ghost" :to="upgradeLink" @click="upgrade">{{ t('purchase.upgrade_pro') }}</AppButton>
      </div>
    </div>
  </AppModal>
</template>
<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import AppModal from '@/components/ui/overlays/AppModal.vue';
import AppButton from '@/components/ui/buttons/AppButton.vue';
import AppAlert from '@/components/ui/feedback/AppAlert.vue';
import PurchaseRepository from '@/repositories/PurchaseRepository';
import { useBenchmarkPurchaseStore } from '@/stores/useBenchmarkPurchaseStore';
import { useTokenBalanceStore } from '@/stores/useTokenBalanceStore';
import { rememberSubscriptionReturnPath } from '@/utils/subscriptionCheckoutReturn';
const store = useBenchmarkPurchaseStore();
const tokens = useTokenBalanceStore();
const { t, locale } = useI18n();
const busy = ref(false);
const error = ref('');
const isPro = computed(() => tokens.planKeys.includes('plan-pro'));
const upgradeLink = { path: '/subscriptions', query: { intent: 'platform', plan: 'pro' } };
const money = computed(() => new Intl.NumberFormat(locale.value, { style: 'currency', currency: 'EUR' }).format((store.purchase?.amount || 0) / 100));
function upgrade() {
  rememberSubscriptionReturnPath(`/account/purchases/${store.purchase.id}`);
  store.choose(false);
}
async function pay() {
  busy.value = true;
  error.value = '';
  try {
    const id = store.purchase.id;
    const { data } = await PurchaseRepository.checkout(id, `/account/purchases/${id}`);
    window.location.assign(data.url);
  } catch (e) { error.value = e?.response?.data?.message || t('purchase.error'); }
  finally { busy.value = false; }
}
</script>
